import React from 'react';
import { message } from 'antd';
import { Route, Redirect } from 'react-router-dom';
import { viewRight } from 'leo-configs/constant';

const PrivateRoute = ({ component: Component, authorities, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!viewRight[location.hash.split('/')[1]]) {
          return <Component {...props} />;
        }
        if (
          authorities.some(
            (right) =>
              viewRight[location.hash.split('/')[1]] &&
              viewRight[location.hash.split('/')[1]].some(
                (item) => item === right
              )
          )
        ) {
          return <Component {...props} />;
        } else {
          message.error('无权限访问此模块，请联系管理员');
          // 这里应该是主页
          return <Redirect to="/" />;
        }
      }}
    />
  );
};

export default PrivateRoute;
